module.exports = __webpack_public_path__ + "img/border_circularAndRight.5686597a.svg";